import React from 'react';
import { Grid, Button, Box } from '@mui/material';

import PlateFormSection from './PlateFormSection';
import SubsidiarySelectorContent from '@shared/components/SubsidiarySelectorContent';
import StyledTextField from '@shared/components/StyledTextField';

import { PaperForm, GridForm } from './styles';
import PlateContactPointSection from './PlateContactPointSection';

import AgeQuantitySelector from '@shared/components/AgeQuantitySelector';

const PlateForm = ({
  formik,
  minorsArray,
  changeYear,
  ID_SITE_CONST,
  subsidiaries,
  subsidiary,
  handleSubsidiarie,
  name,
  payee,
}) => {
  const contactFields = [
    { name: 'first_name', label: 'Nombre' },
    { name: 'last_name', label: 'Apellido' },
    { name: 'whatsapp', label: 'Whatsapp' },
    { name: 'email', label: 'Email' },
  ];

  const onSelectAgency = agency => {
    payee.handleSelectSubsidiary(agency);

    formik.setFieldValue('id_entity', agency?.id || '');
  };

  const entityError = formik.touched.id_entity && formik.errors.id_entity;

  return (
    <GridForm item xs={12}>
      <PaperForm elevation={0} paperSx={{ p: 2 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container columnSpacing={5} rowSpacing={2}>
            {/* DATOS DE CONTACTO */}
            <PlateFormSection
              title="Datos de contacto"
              md={4}
              sectionGridProps={{
                gridSx: { pt: 1 },
                customLayout: {
                  md: {
                    1: 6,
                    2: 6,
                    3: 4,
                    4: 8,
                  },
                },
              }}
            >
              {contactFields.map(field => (
                <StyledTextField
                  key={field.name}
                  name={field.name}
                  formik={formik}
                  label={field.label}
                />
              ))}
            </PlateFormSection>

            {/* FECHAS */}
            <PlateFormSection
              title="Elegí cuando viajar"
              item
              xs={12}
              md={2}
              sectionGridProps={{
                gridSx: { pt: 1 },
                customLayout: {
                  md: {
                    1: 12,
                    2: 12,
                  },
                },
              }}
            >
              <StyledTextField
                formik={formik}
                name="date_from"
                label="Fecha desde"
                type="date"
                inputProps={{
                  min: new Date().toISOString().split('T')[0], // hoy en formato YYYY-MM-DD
                }}
              />

              <StyledTextField
                formik={formik}
                name="date_to"
                label="Fecha hasta"
                type="date"
                inputProps={{
                  min:
                    formik.values.date_from ||
                    new Date().toISOString().split('T')[0], // no antes de date_from
                }}
              />
            </PlateFormSection>

            {/* PASAJEROS */}
            <PlateFormSection
              title="Pasajeros"
              md={2}
              sectionGridProps={{
                gridSx: { pt: 0 },
                customLayout: {
                  xs: { 1: 12, 2: 12 },
                },
              }}
            >
              <AgeQuantitySelector
                defaultAdults={formik.values.adults_quantity}
                defaultMinors={minorsArray.map((m, i) => ({
                  childNumber: i + 1,
                  age: m.age || 17,
                }))}
                onChange={({ adults, minors }) => {
                  formik.setFieldValue('adults_quantity', adults);
                  formik.setFieldValue('minors_quantity', minors.length);

                  minors.forEach(m => changeYear(m.age, m.childNumber - 1));
                }}
              />
            </PlateFormSection>

            {/* PUNTOS DE VENTA */}
            {+ID_SITE_CONST !== 3 && (
              <PlateFormSection
                title="Puntos de venta"
                md={4}
                sectionGridProps={{
                  gridSx: { pt: 1 },
                  customLayout: {
                    xs: { 1: 12, 2: 12 },
                  },
                }}
              >
                <SubsidiarySelectorContent
                  subsidiaries={subsidiaries}
                  subsidiary={subsidiary}
                  handleSubsidiarie={onSelectAgency}
                  name={name}
                  error={!!entityError}
                  helperText={entityError}
                />
              </PlateFormSection>
            )}
          </Grid>

          {/* CONTACTO DE PAGO */}
          {Object.keys(subsidiary).length !== 0 && (
            <Box sx={{ mt: 3 }}>
              <PlateContactPointSection
                subsidiary={subsidiary}
                setSubsidiary={handleSubsidiarie}
              />
            </Box>
          )}

          {/* ENVIO SITE 3 */}
          {ID_SITE_CONST == 3 && (
            <Box display="flex" justifyContent="center">
              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  sx={{ mt: 1 }}
                >
                  Enviar
                </Button>
              </Grid>
            </Box>
          )}
        </form>
      </PaperForm>
    </GridForm>
  );
};

export default PlateForm;
